module.exports = __webpack_public_path__ + "img/xlsx.f2a5089.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/advancedVersion/xlsx.png
// module id = sVxE
// module chunks = 2 3 6 8 15 49